module.exports = __webpack_public_path__ + "static/media/jose-luis-dorronsoro.1f0f483b.jpg";